import { render, staticRenderFns } from "./ActiveBook.vue?vue&type=template&id=55197baa"
import script from "./ActiveBook.vue?vue&type=script&lang=js"
export * from "./ActiveBook.vue?vue&type=script&lang=js"
import style0 from "./ActiveBook.vue?vue&type=style&index=0&id=55197baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports